import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '@af-create/Store';
import PatternBrowserCategoryList, { Props } from '../_components/PatternBrowserCategoryList';
import { OnSelectCategory, OnResetPatterns, GetPatterns, GetPatternCategories } from '../../_actions/PatternActions';

const mapStateToProps = (store:Store, props:Props) => ({
	loading: store.getIn(['UIData', 'loaders', 'patterns']),
	categories: store.getIn(['patternDesignService','categories']),
	patterns: store.getIn(['patternDesignService','patterns']),
	offset: store.getIn(['patternDesignService', 'offset']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onSelectCategory: (id:string) => dispatch(OnSelectCategory(id)),
	resetPatterns: () => dispatch(OnResetPatterns()),
	getCategories: () => dispatch(GetPatternCategories()),
	getPatterns: (categoryId:string, search:string, limit:number, offset: number) => dispatch(GetPatterns(categoryId, search, limit, offset)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PatternBrowserCategoryList);